import CHElement from "./CHElement";
import EntityStats from "./EntityStats";
import { User } from "./User";

class MyList {
  constructor(
    public id_user: number,
    public name: string,
    public description: string | undefined,
    public icon: number | undefined,
    public id?: number | undefined,
    public GUID?: string | undefined,
    public created_on?: string | undefined,
    public icon_path?: string | undefined,
    public counts?: EntityStats[] | undefined,
    public username?: string | undefined,
    public id_chelements?: number[],
    public chelements?: CHElement[],
    public id_users?: number[],
    public users?: User[],
  ) {}

  public static EmptyInstance(): MyList {
    return new MyList(-1, "", "", -1);
  }
}

export default MyList;
